import { render, staticRenderFns } from "./AiVoiceCall.vue?vue&type=template&id=23843ec7&scoped=true"
import script from "./AiVoiceCall.vue?vue&type=script&lang=js"
export * from "./AiVoiceCall.vue?vue&type=script&lang=js"
import style0 from "./AiVoiceCall.vue?vue&type=style&index=0&id=23843ec7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23843ec7",
  null
  
)

export default component.exports